<div class="dp" data-testid="dp-root">
  @if (!chatTakesOver()) {
    <div class="nav-bar" [class.dp-concealed]="foldedByWindow()" [attr.inert]="foldedByWindow() ? '' : null" [style.display]="nativePresentationHidden ? 'none' : null">
      @if (!minimized && selectedApp) {
        <!-- The app picker is the button that opens its menu (TW-PANEL-07): named by the app's title, Enter and Space native. -->
        <button
          type="button"
          class="app-selector bg-transparent border-0 p-0 [font:inherit] text-inherit text-left"
          [appContextMenu]="selectedApp"
          [appContextMenuDP]="true"
          [appContextMenuChat]="chatOffered()"
          (appContextMenuChange)="handleAppChange($event)"
          (appContextMenuOpened)="appContextMenuOpened = $event"
          aria-haspopup="menu"
          [attr.aria-expanded]="!!appContextMenuOpened"
        >
          <div class="app">
            <mat-icon class="app-icon" aria-hidden="true" [svgIcon]="selectedApp | appIcon" />
          </div>

          <app-dropdown-label [collapsed]="!appContextMenuOpened" class="font-semibold">
            {{ selectedApp | appTitle }}
          </app-dropdown-label>
        </button>
      }

      @if (!minimized) {
        <!-- Names the workspace the panel lists. Inside a team it is the panel's OWN menu (TW-PANEL-02): it starts
             where the main area is, then only this menu changes it. -->
        <ng-template #workspaceLabel>
          <span class="min-w-0 truncate text-sm text-gray-500" data-testid="dp-workspace-label">{{ workspaceName() }}</span>
        </ng-template>
        @if (workspaceChoice(); as choice) {
          <button
            type="button"
            class="dp-workspace-trigger"
            aria-label="Choose side panel workspace"
            aria-haspopup="menu"
            [attr.aria-expanded]="workspaceMenuOpen()"
            stchPopover
            stchPopoverTrigger="click"
            [stchPopoverTemplate]="workspaceMenu"
            stchPopoverPlacement="bottomLeft"
            [stchPopoverOffsetY]="2"
            [stchPopoverCloseOnOutsideClick]="true"
            [stchPopoverShowUntil]="closeWorkspaceMenu"
            [stchPopoverNoBorder]="true"
            (stchPopoverVisibleChange)="workspaceMenuOpen.set($event)"
          >
            <ng-container *ngTemplateOutlet="workspaceLabel" />
            <app-icon name="sapphire-chevron-down" size="s" />
          </button>
          <ng-template #workspaceMenu>
            <div class="dp-workspace-menu" role="menu" aria-label="Side panel workspace">
              <button
                type="button"
                role="menuitemradio"
                class="dp-workspace-menu-row"
                [attr.aria-checked]="choice.mine"
                (click)="pickWorkspace(choice.identity.memberTenantId)"
              >
                <span>My Workspace</span>
                @if (choice.mine) {
                  <app-icon name="sapphire-check" size="s" />
                }
              </button>
              <button
                type="button"
                role="menuitemradio"
                class="dp-workspace-menu-row"
                [attr.aria-checked]="!choice.mine"
                (click)="pickWorkspace(choice.identity.spaceTenantId)"
              >
                <span>{{ choice.identity.spaceTitle }}</span>
                @if (!choice.mine) {
                  <app-icon name="sapphire-check" size="s" />
                }
              </button>
            </div>
          </ng-template>
        } @else if (spaceContextStore.insideTeam()) {
          <ng-container *ngTemplateOutlet="workspaceLabel" />
        }
      }

      @if (!minimized && accessLimited()) {
        <!-- A limited account (failed payment): every app here is still readable, and the pill says AI and creating
             new items are paused. -->
        <span
          class="ml-auto inline-flex h-12 items-center gap-3 rounded-[40px] border border-orange-500 bg-orange-50 px-4 text-sm font-medium text-orange-700"
          data-testid="dp-paused-status"
        >
          <span class="size-3 rounded-full bg-orange-500"></span>
          Paused
        </span>
      }

      @if (!minimized && (selectedApp === Application.boards || selectedApp === Application.forms)) {
        <!-- Boards only: the prototype's heading controls (NativePanel.tsx fourth-header-actions, Boards.tsx:317). Expand toggles the panel
             between 320 and 540 px; Close folds it, as the split-view toggle does. Every other app's heading is unchanged. -->
        <div class="flex items-center gap-2" [class.ml-auto]="!accessLimited()" [class.ml-4]="accessLimited()" [attr.data-test]="selectedApp === Application.boards ? 'boards-heading-actions' : 'forms-heading-actions'">
          <app-button2 appearance="secondary-ghost" size="xs" ariaLabel="Expand fourth panel" [attr.data-test]="selectedApp === Application.boards ? 'boards-panel-expand' : 'forms-panel-expand'" (click)="toggleBoardsWidth()">
            <app-icon name="expand" size="s" />
          </app-button2>
          <app-button2 appearance="secondary-ghost" size="xs" ariaLabel="Close fourth panel" [attr.data-test]="selectedApp === Application.boards ? 'boards-panel-close' : 'forms-panel-close'" (click)="closeBoardsPanel()">
            <app-icon name="sapphire-close" size="s" />
          </app-button2>
        </div>
      }

      @if (!minimized && stitchyOffered() && !chatStore.isOpen()) {
        <app-stitchy-launcher
          [class.ml-auto]="!accessLimited() && selectedApp !== Application.boards && selectedApp !== Application.forms"
          [class.ml-2]="selectedApp === Application.boards || selectedApp === Application.forms"
          [class.ml-4]="accessLimited()"
          variant="nav"
          [status]="launcherStatus()"
          [unseen]="chatStore.hasUnseen()"
          (clicked)="chatStore.open()"
        />
      }
    </div>

    <ng-container *stchRerender="bodyKey()">
      @if (mainWorkspaceApplied() && !minimized && (!item || selectedApp === null)) {
        <div class="body" [class.dp-concealed]="foldedByWindow()" [attr.inert]="foldedByWindow() ? '' : null" [style.display]="nativePresentationHidden ? 'none' : null">
          @switch (selectedApp) {
            @case (null) {
              <app-no-content-stub>
                <div class="flex max-w-full flex-col items-center gap-2">
                  <p class="text-base font-medium text-gray-900 text-center">No apps in this workspace yet</p>
                  <p class="text-sm text-gray-600 text-center">Ask the workspace owner for access.</p>
                </div>
              </app-no-content-stub>
            }
            @case (Application.kp) {
              <app-knowledge-panel />
            }
            @case (Application.mail) {
              <app-messages2-panel *appMailAppContext/>
            }
            @case (Application.calendar) {
              <app-events-panel *appCalendarAppContext />
            }
            @case (Application.tasking) {
              <app-tasks-panel *appTaskingAppContext />
            }
            @case (Application.notes) {
              <app-notes-panel *appNotesAppContext />
            }
            @case (Application.sheets) {
              <app-sheets-panel *appSheetsAppContext/>
            }
            @case (Application.contacts) {
              <app-contacts-panel *appContactsAppContext />
            }
            @case (Application.files) {
              <app-files-panel *appFilesAppContext />
            }
            @case (Application.chat) {
              <app-lazy-space-chat-panel />
            }
            @case (Application.slides) {
              <app-lazy-slides-view view="panel" />
            }
            @case (Application.forms) { <app-forms-layout [panel]="true"/> }
              @case (Application.boards) {
              <app-boards-panel />
            }
            @case (Application.atlas) {
              <!-- The outlet is a thin standalone seam whose own `@defer` splits the panel host, the
                   inspector and the Atlas read-stores into their own chunk — keeping them out of the eager
                   shell bundle. A `@defer` here could not: this NgModule host's compilation scope is eager,
                   so a module-imported panel would ship eagerly whatever the template did. -->
              <app-atlas-panel-outlet />
            }
          }
        </div>
      }
    </ng-container>

    @if (!minimized && !!item && selectedApp) {
      <app-dynamic-panel-forms-container [class.dp-concealed]="foldedByWindow()" [attr.inert]="foldedByWindow() ? '' : null" [style.display]="nativePresentationHidden ? 'none' : null" />
    }
  }

  @if (hasAgentAccess()) {
    <!-- Only a DOCKED chat follows `minimized`: it is laid out inside the DP, so it would otherwise
         fill the collapsed 15px strip and peek through. A FLOATING chat is `position: fixed` against
         the viewport and coexists with the DP by design (see `chatTakesOver`).
         Hidden rather than @if-removed so ChatInputBar's local draft/mentions/attachments survive
         re-open. Inline style rather than a class binding to keep the rule next to its condition (a
         DP-scoped class would work too, it just puts the rule in another file). -->
    <app-lazy-stitchy-panel [hidden]="dockedChatHidden" />
  } @else if (teaser.active()) {
    <!-- A Free Trial without Stitchy (SBUX-1231): the same window, laid out and hidden as the real panel is. -->
    <app-lazy-stitchy-teaser-panel [hidden]="dockedChatHidden" />
  }

  <!-- Shown whenever the collapsed DP leaves NO chat visible — closed, or open-but-docked (which the
       binding above hides). Keying it on `!isOpen()` alone stranded the user: collapsing the DP with a
       docked chat open, or docking a floating one from here, hid the chat and the launcher at once. -->
  @if (stitchyOffered() && (minimized || foldedByWindow()) && (!chatStore.isOpen() || chatStore.isDocked())) {
    <app-stitchy-launcher
      class="fixed bottom-24 right-12 z-[200]"
      variant="fab"
      [status]="launcherStatus()"
      [unseen]="chatStore.hasUnseen()"
      (clicked)="openChat()"
    />
  }
</div>
